module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/7m-584f4408191ebc701055534eef87e446.jpg";